import React from 'react'

const About = ({
    aboutRef,
    frontendRef,
    backendRef,
    aboutProfilePhotoRef,
    aboutDescriptionRef,
    sendEmail
}) => {
    const url_path = "./profile.jpg"
    return (
        <div className="bg-white text-[#59595B] min-h-[200vh] "
            // [#6C7059]
            ref={aboutRef}
            id={`about`}
        >
            <div
                ref={frontendRef}
                className="text-[10vw] w-[200vw] ml-[10vw] hover:text-[#E65445]">  Frontend - Flutter/React Developer </div>
            <hr className="border-t mx-[1.7vh] border-[#59595B] border:text-[#E65445]" />
            <div
                ref={backendRef}
                className="text-[10vw] w-[200vw] ml-[5vw] hover:text-[#E65445]">  Backend - Restful/Graphql </div>
            <div
                className="lg:flex mt-[10vh] mx-[2vh] lg:mr-[10vh] 2xl:mr-[20vh] text-[2vh] sm:text-[3vh]"
                style={{ whiteSpace: "pre-wrap" }}
            >
                <img
                    ref={aboutProfilePhotoRef}
                    className="hidden lg:block rounded h-[70vh] w-[50vh] mx-auto object-cover"
                    src={url_path}
                    alt="Card" />
                <img
                    className="lg:hidden rounded h-[70vh] w-[50vh] mb-[4vh] mx-auto object-cover"
                    src={url_path}
                    alt="Card" />
                <div
                    ref={aboutDescriptionRef}
                    className="max-w-[60vh] mx-auto lg:pl-4 lg:mx-0 text-justify pb-[8vh]">

                    {"Hi! I am Zul Aiman also known as Manza. I am a react developer, flutter developer, REST/GraphQL developer and system analyst working from Malaysia (Selangor) to everywhere.\n\n" +
                        "Born and raised here in Malaysia, I have more than 3 years experience in system development. I started as a NoSQL developer and soon after explored into SQL and decentralized databases. Not long after I have also dive into the react habitat of creating frontends. UI/UX design comes naturally when exploring the frontends. In a nutshell, I like to understand the entire movie script.\n\n" +
                        "I love to bring my own style of system design by analyzing and understanding the nature of each application. It forms a map to explore. Now I am a database developer at Project Oasis (GoShare). I love exploring ideas and making stuff. It drives a feeling of excitement.\n\n" +
                        "If you would like to see my portfolio just hop to my "}<label className="underline text-[#E65445] hover:text-[#2B292A]" onClick={() => window.open("https://github.com/zaimanza")} >GitHub</label>{", or send me an "}<label className="cursor-pointer underline text-[#E65445] hover:text-[#2B292A]" onClick={sendEmail}>email</label>{" for any enquiries.\n\n" +
                            "You can also find me on "}<label className="underline text-[#E65445] hover:text-[#2B292A]" onClick={() => window.open("https://www.instagram.com/manza.z")}>Instagram</label>{"."}
                </div>
            </div>
        </div>
    )
}

export default About